export default __webpack_public_path__ + "static/media/meu-pe-de-cacau.b48cb180.png";